<template>
  <el-drawer
    custom-class="drawer-custom-class"
    append-to-body
    :close-on-press-escape="false"
    :title="title"
    size="600px"
    :visible.sync="visible"
    direction="rtl"
    @closed="onClosed">
    <div
      v-loading="loading"
      class="drawer-wrap">
      <div class="search-from">
        <div>
          <el-button
            v-if="enable"
            type="primary"
            @click="editItem({})">新增库位</el-button>
        </div>
        <el-input
          v-model="config.binNo"
          style="width: 240px"
          clearable=""
          placeholder="请输入库位编码">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          label="库位编号"
          width="120"
          prop="binNo"></el-table-column>
        <el-table-column
          label="当前库存数"
          min-width="90"
          prop="count"></el-table-column>
        <el-table-column
          label="当前待回寄数（且已付款数）"
          min-width="120"
          prop="countInfo"></el-table-column>
        <el-table-column
          v-if="enable"
          label="操作"
          fixed="right"
          width="100">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="editItem(row)">修改</el-button>
            <!-- <el-button type="text">查看详情</el-button> -->
            <el-dropdown>
              <el-button
                style="margin-left: 10px;"
                type="text">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="deleteItem(row)">删除</el-dropdown-item>
                <el-dropdown-item @click.native="viewDetail(row)">查看详情</el-dropdown-item>
                <el-dropdown-item @click.native="getbinnoqrcode(row)">下载库位码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align: center;"
        :current-page="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
    <binset-edit-modal
      ref="binset"
      @fetch="fetchList" />

    <binset-inventory-modal ref="inventory" />
  </el-drawer>
</template>
<script>
import Wms from '@/service/wms'
import BinsetEditModal from './binset-edit-modal.vue'
import { downloadBlobFile } from '@/utils/index'
import BinsetInventoryModal from './binset-inventory-modal.vue'
export default {
  name: 'BinsetModal',
  components: { BinsetEditModal, BinsetInventoryModal },
  props: {
    enable: { type: Boolean, default: true }
  },
  data() {
    return {
      visible: false,
      loading: false,
      config: { pageNum: 1, pageSize: 10, warehouseId: null, warehouseName: '', binNo: '' },
      list: [],
      total: 0
    }
  },
  computed: {
    title({ config }) {
      return `库位管理（${config.warehouseName}）`
    }
  },
  methods: {
    getbinnoqrcode(row) {
      this.loading = true
      const { binId } = row
      Wms.getbinnoqrcode({ binId })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
          this.$message.success('下载成功')
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    viewDetail(row) {
      const { binId, binNo } = row
      this.$refs.inventory.fetch({ binId, binNo })
    },
    editItem(row) {
      const { warehouseId } = this.config
      const { binId = null, binNo = '' } = row
      this.$refs.binset.init({ warehouseId, binId, binNo })
    },
    deleteItem(row) {
      this.$confirm('此操作将永久删除该库位, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Wms.deletebinset({ binId: row.binId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    onClosed() {
      this.config = { ...this.config, ...this.$options.data().config }
      this.total = 0
      this.list = []
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Wms.getbinsets({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if (result === 0) {
            this.list = records.map(i => {
              const { stockBalance, frozenQty, isSettlementedNum, inSettlementNum, badDebtNum } = i
              const count = stockBalance + frozenQty
              const countInfo = `${isSettlementedNum}(${isSettlementedNum + inSettlementNum + badDebtNum})`
              return { ...i, count, countInfo }
            })
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(optins = {}) {
      this.config = { ...this.config, ...optins }
      this.fetchList()
      this.visible = true
    }
  }
}
</script>
